import { UserManager, WebStorageStateStore } from 'oidc-client-ts';

const env = window.env;
const userManager = new UserManager({
  authority: env.auth.authUrl,
  redirect_uri: env.auth.redirectUrl,
  post_logout_redirect_uri: env.auth.logofRedirectUrl,
  client_id: env.auth.clientID,
  silent_redirect_uri: env.auth.logoutUrl,
  automaticSilentRenew: true,
  scope: 'openid application:fundacao_programas_educacionais',
  response_type: 'code',
  userStore: new WebStorageStateStore({ store: window.localStorage }),
});
export default userManager;
